<template>
  <div v-if="user && apiKeysLoading === false" class="apis-services">
    <template v-if="hasAPI">
      <div class="row justify-center q-col-gutter-x-lg q-col-gutter-y-md q-mb-md">
        <dashboard-card
          class="col-md-6 col-12"
          icon="article"
          title="Documentation"
          description="Discover our range of APIs, including our endpoints, parameters, responses, and authentication requirements."
          href="https://docs.hellodata.ai/"
          action-label="Documentation"
        />
        <dashboard-card
          class="col-md-6 col-12"
          icon="code"
          title="API Key"
          description="Use the provided key in your requests to gain access to our suite of APIs. You are billed at the end of the month according to usage."
          hide-action
        >
          <q-input
            :model-value="apiKeys[0]?.key"
            :type="seeApiKey ? undefined : 'password'"
            color="primary"
            outlined
            readonly
            :loading="apiKeysLoading"
          >
            <template v-if="!apiKeysLoading" #append>
              <q-btn round unelevated flat size="sm" @click="seeApiKey = !seeApiKey">
                <q-icon :name="seeApiKey ? 'visibility_off' : 'visibility'" />
              </q-btn>
            </template>
          </q-input>
        </dashboard-card>
      </div>
      <usage />
    </template>
    <bulk-data v-if="hasBulkData" class="q-mt-md" />
    <div v-if="!hasAPI && !hasBulkData" class="q-my-xl">
      <not-subscribed />
    </div>
  </div>
</template>

<script lang="ts">
import { useStripeStore } from '@/stores/stripe'
import DashboardCard from '@/components/DashboardCard.vue'
import NotSubscribed from '@/components/ApiServices/NotSubscribed.vue'
import Usage from '@/components/ApiServices/UsageTable.vue'
import BulkData from '@/components/ApiServices/BulkData.vue'

export default {
  name: 'ApisServices',
  components: {
    Usage,
    BulkData,
    DashboardCard,
    NotSubscribed
  },
  data() {
    return {
      seeApiKey: false,
      apiKeysLoading: null as boolean | null
    }
  },
  computed: {
    user() {
      return this.$auth0.user.value
    },
    apiKeys(): { key: string }[] {
      return useStripeStore().apiKeys
    },
    hasAPI(): number {
      return useStripeStore().apiKeys.length
    },
    hasBulkData(): boolean {
      return useStripeStore().hasBulkData
    }
  },
  created() {
    if (!this.apiKeys.length) {
      this.refreshApiKeys()
    } else {
      this.apiKeysLoading = false
    }
  },
  methods: {
    refreshApiKeys() {
      this.apiKeysLoading = true
      useStripeStore()
        .initCustomerApiKeys()
        .then(() => {
          this.apiKeysLoading = false
        })
    }
  }
}
</script>
<style scoped>
.apis-services {
  max-width: 1280px;
  margin: auto;
}
</style>
